var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Field } from 'redux-form';
import PhoneInput from 'react-phone-number-input/native';
import { getCountryCallingCode, parseNumber } from 'libphonenumber-js/custom';
import metadata from 'libphonenumber-js/metadata.min.json';
import FlagsComponent from './APPhoneInputFlags';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import config from '../../../config';
import 'react-phone-number-input/style.css';
import './APPhoneInput.css';
var baseClass = 'ap-phone-input';
var APPhoneInnerInput = function (_React$Component) {
  _inherits(APPhoneInnerInput, _React$Component);
  function APPhoneInnerInput(props) {
    _classCallCheck(this, APPhoneInnerInput);
    var _this = _possibleConstructorReturn(this, (APPhoneInnerInput.__proto__ || Object.getPrototypeOf(APPhoneInnerInput)).call(this, props));
    _this.onChange = function (value, phone) {
      var _this$props = _this.props,
        onChange = _this$props.input.onChange,
        name = _this$props.name;
      var _this$state = _this.state,
        countryPrefix = _this$state.countryPrefix,
        countryCode = _this$state.countryCode;
      var meta = {
        countryPrefix: countryPrefix,
        countryCode: countryCode,
        noPrefixPhone: phone && phone.replace('+' + countryPrefix, '')
      };
      onChange(value, phone, meta, name);
    };
    _this.onCountryChange = function (countryCode) {
      var countryPrefix = getCountryCallingCode(countryCode, metadata);
      _this.setState({
        countryPrefix: countryPrefix,
        countryCode: countryCode
      });
    };
    _this.onFocus = function () {
      _this.setState({
        focused: true
      });
    };
    _this.onBlur = function () {
      _this.setState({
        focused: false
      });
    };
    _this.state = {
      phone: props.value,
      focused: false,
      countryPrefix: null,
      countryCode: null
    };
    return _this;
  }
  _createClass(APPhoneInnerInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        customClass = _props.customClass,
        classModifiers = _props.classModifiers,
        info = _props.info,
        label = _props.label,
        rightLabelText = _props.rightLabelText,
        _props$meta = _props.meta,
        error = _props$meta.error,
        dirty = _props$meta.dirty;
      var bemClasses = getBEMClasses([baseClass, customClass]);
      return React.createElement('div', {
        className: 'form-group ' + bemClasses('input-wrapper', classModifiers),
        onFocus: this.onFocus,
        onBlur: this.onBlur
      }, React.createElement('label', {
        className: 'ap--label ' + bemClasses('label', classModifiers)
      }, label), React.createElement('div', {
        className: classnames(rightLabelText && bemClasses('input-with-right-label-container'), bemClasses('input-box'))
      }, React.createElement(PhoneInput, {
        name: 'telephone',
        value: this.state.phone,
        flagComponent: FlagsComponent,
        international: false,
        displayInitialValueAsLocalNumber: true,
        country: this.props.country || config.global.phoneDefaultCountry,
        countries: config.global.phoneWhiteListCountries,
        placeholder: this.props.placeholder,
        inputClassName: bemClasses('input'),
        onChange: this.onChange,
        onCountryChange: this.onCountryChange,
        metadata: metadata
      }), info && React.createElement('div', {
        className: 'form-text-muted ' + bemClasses('info')
      }, info), dirty && error && React.createElement('div', {
        className: bemClasses('error')
      }, error)));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps) {
      var phone = nextProps.value;
      if (phone) {
        var parsed = parseNumber(phone, metadata);
        if (parsed.country) {
          var countryCode = parsed.country;
          var countryPrefix = countryCode && getCountryCallingCode(countryCode, metadata);
          return {
            phone: phone,
            countryCode: countryCode,
            countryPrefix: countryPrefix
          };
        }
      }
      return {
        phone: phone
      };
    }
  }]);
  return APPhoneInnerInput;
}(React.Component);
APPhoneInnerInput.defaultProps = {
  name: '',
  customClass: '',
  placeholder: '',
  label: '',
  value: '',
  country: '',
  onChange: function onChange() {}
};
APPhoneInnerInput.propTypes = {
  name: PropTypes.string,
  customClass: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  country: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool
};
var APPhoneInput = function APPhoneInput(props) {
  return React.createElement(Field, Object.assign({
    name: props.name,
    component: APPhoneInnerInput
  }, props));
};
APPhoneInput.defaultProps = {
  name: '',
  label: '',
  labelInInput: '',
  type: '',
  classModifiers: '',
  placeholder: '',
  info: '',
  autoFocus: '',
  disabled: false,
  required: false,
  rows: 1
};
APPhoneInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  labelInInput: PropTypes.string,
  type: PropTypes.string,
  customClass: PropTypes.string,
  classModifiers: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  placeholder: PropTypes.string,
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  autoFocus: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  rightLabelText: PropTypes.string,
  rows: PropTypes.number
};
export default APPhoneInput;